export default __webpack_public_path__ + "316c14c7660b9d0f6e699335fb074e33.svg";